import React from 'react';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import UIPageTitle from 'components/UI/PageTitle/PageTitle';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import UIButton from 'components/UI/Button/Button';

function ScreensUserChangePasswordDone() {
  return (
    <BaseLayout>
      <DocumentTitle>Change Password</DocumentTitle>
      <UIPageTitle>Success!</UIPageTitle>
      <p>Your password has been changed.</p>
      <p>Please use this password next time you sign in.</p>
      <br />
      <UIButton to="/" theme="contained-green">
        Continue
      </UIButton>
    </BaseLayout>
  );
}

export default ScreensUserChangePasswordDone;
